module.exports = __webpack_public_path__ + "img/logo-menu.26fe993.png";